<script>
    import {onMount,onDestroy} from 'svelte'
    export let duration = 1000

    let visible = true
    onMount(()=>{
        setTimeout(()=>{
            visible = false
        },duration)
    })

</script>
<style>
        .svg-container {
            background-color: red;
            width: 100vw;
            height: 100vh;
        }
        svg.cover-page {

            width:100%;
            height: 100%;
            text-align: right;
        }
        svg  text {
            stroke:#666 ;
            fill:#054;
        }
        .cover-title {
            font-size:25px;
            font-family:'Cairo';
            stroke:#666 ;
            fill:#054;
            
        }
</style>
{#if visible }
<div class="h-screen w-screen bg-green-700 text-white text-center overflow-hidden">
    <div class="svg-container">
        <svg class="cover-page" xmlns="http://www.w3.org/2000/svg" >
            <rect x="0" y="0" width="100%" height="100%" fill="#15815d"></rect>
            <g>
                <rect x="12%" y="50" ry="80" width="110%" height="180" stroke="#00ffaa" fill="none" stroke-width="4"></rect>
                <rect x="15%" y="60" ry="70" width="100%" height="160" fill="#fff"></rect>
                <text class="cover-title" x="30" y="120" dx="50%" writing-mode="rl-tb" text-anchor="middle"
                style="font-size: 60px;">
                    دليل
                </text>
                <text class="cover-title"
                 x="30" y="170"
                  dx="50%" writing-mode="rl-tb"
                   text-anchor="middle">
                    محطات التحويل الثانوية
                </text>
                
            </g>
            <ellipse rx="40" ry="40" cx="80%" cy="50%" fill="#fff"></ellipse>
            <g>
                <rect x="-10%" y="70%" ry="50" width="100%" height="100" stroke="#00ffaa" fill="none" stroke-width="4"></rect>
                <rect x="-12%" y="70.7%" ry="40" width="100%" height="90" fill="#fff"></rect>
                <!-- <text x="30%" y="75%" font-family="Cairo" font-size="18">
                        فكرة وعمل وإعداد 
                </text>
                <text x="25%" y="80%" font-family="Cairo" font-size="18">
                       المراقب : زيد مزيد المويزري
                </text> -->
            </g>
            <line x1="0" y1="90.5%" x2="100%" y2="90.5%" stroke="#acf6f8" stroke-width="10"></line>
        </svg>
    </div>
</div>
{:else}
    <slot></slot>
{/if}